import React from 'react'

const Main = (props) => {
  return (
    <div className="bg-[#FDF5EE] w-[calc(100vw-100px)] xs:w-screen min-h-[calc(100vh-40px)] xs:min-h-[calc(100vh-80px)] mt-[20px] xs:mt-[80px] flex flex-wrap justify-between rounded-l-[20px] xs:rounded-[10px] xs:flex-col-reverse sm:flex-col-reverse md:flex-col-reverse">{props.children}</div>
  )
}

export default Main